/**
 * Serializable error model for the domain layer.
 * Decoupled from Axios or any specific HTTP library.
 */
export interface ApiErrorResponse {
    statusCode: number;
    message: string;
    code?: string;
    details?: unknown;
}

/**
 * Functional approach to API Errors.
 * Instead of a class, we use a simple object creator or just the interface.
 */
export const createApiError = (payload: ApiErrorResponse): ApiErrorResponse => {
    return {
        statusCode: payload.statusCode,
        message: payload.message,
        code: payload.code,
        details: payload.details,
    };
};

/**
 * Type guard to check if an object is an ApiErrorResponse.
 */
export const isApiError = (error: any): error is ApiErrorResponse => {
    return (
        error &&
        typeof error.statusCode === 'number' &&
        typeof error.message === 'string'
    );
};
